export const SITE_URL = 'https://rinkdata.com';
export const DEFAULT_OG_IMAGE = `${SITE_URL}/images/og-image.png`;

export const PAGE_SEO = {
  home: {
    path: '/',
    title: 'RINK Data | AI Web Scraping & Lead Data Platform',
    description:
      'Extract structured web data with RINK A.I. — scrapers for real estate, business leads, Google Business, and CRM integrations. Start collecting data in minutes.',
  },
  about: {
    path: '/about',
    title: 'About RINK Data | AI Scraping Since 2005',
    description:
      'Learn about RINK Data — patented AI web scraping and data intelligence for sales teams, real estate, and business lead generation.',
  },
  pricing: {
    path: '/pricing',
    title: 'Pricing | RINK Data Web Scraping Plans',
    description:
      'Transparent RINK Data pricing for AI web scraping, lead extraction, and CRM integrations. Choose the plan that fits your team.',
  },
  reviews: {
    path: '/reviews',
    title: 'Customer Reviews | RINK Data',
    description:
      'See what customers say about RINK Data’s AI web scraping platform for real estate and business lead generation.',
  },
  contact: {
    path: '/contact',
    title: 'Contact RINK Data | Demo & Support',
    description:
      'Contact RINK Data for a demo, sales questions, or support. Based in Raleigh, NC — phone (919) 679-1559.',
  },
  'web-scraping': {
    path: '/web-scraping',
    title: 'Web Scraping Solutions | RINK Data',
    description:
      'AI-powered web scrapers for Zillow, Trulia, Craigslist, Google Business, Facebook, Yellow Pages, and more. Export to Excel, CSV, JSON, or API.',
  },
  'web-integrations': {
    path: '/web-integrations',
    title: 'Web Integrations | RINK Data CRM & APIs',
    description:
      'Connect RINK Data scrapers to Salesforce, HubSpot, Zapier, Zoho, Pipedrive, and custom APIs for automated lead workflows.',
  },
  privacy: {
    path: '/privacy',
    title: 'Privacy Policy | RINK Data',
    description: 'How RINK Data collects, uses, and protects personal information on our platform and APIs.',
  },
  terms: {
    path: '/terms',
    title: 'Terms of Service | RINK Data',
    description: 'Terms of service for using the RINK Data web scraping and data intelligence platform.',
  },
  login: {
    path: '/login',
    title: 'Login | RINK Data',
    description: 'Sign in to your RINK Data account to manage scrapers, jobs, and results.',
    robots: 'noindex, nofollow',
  },
};

export const PATH_TO_PAGE = {
  '/': 'home',
  '/about': 'about',
  '/pricing': 'pricing',
  '/reviews': 'reviews',
  '/contact': 'contact',
  '/web-scraping': 'web-scraping',
  '/web-integrations': 'web-integrations',
};

export const PAGE_TO_PATH = {
  home: '/',
  about: '/about',
  pricing: '/pricing',
  reviews: '/reviews',
  contact: '/contact',
  'web-scraping': '/web-scraping',
  'web-integrations': '/web-integrations',
  solutions: '/web-scraping',
};

export function getOrganizationJsonLd() {
  return {
    '@context': 'https://schema.org',
    '@type': 'SoftwareApplication',
    name: 'RINK Data',
    applicationCategory: 'BusinessApplication',
    operatingSystem: 'Web, iOS, Android',
    url: SITE_URL,
    description:
      'AI-powered web scraping and data intelligence platform for lead generation, real estate data, and CRM integrations.',
    offers: {
      '@type': 'Offer',
      url: `${SITE_URL}/pricing`,
    },
    publisher: {
      '@type': 'Organization',
      name: 'RINK Data',
      url: SITE_URL,
      email: 'support@rinkdata.com',
      telephone: '+1-919-679-1559',
      address: {
        '@type': 'PostalAddress',
        addressLocality: 'Raleigh',
        addressRegion: 'NC',
        addressCountry: 'US',
      },
    },
  };
}
